import { SettingsField } from 'src/types/page-generator';

import commonSettings from '../../common/settings';

const settings: SettingsField[] = [...commonSettings];

export default settings;
